module.exports = __webpack_public_path__ + "img/img-store-step2.51b99f59.svg";